import filter from 'array-filter';
import map from 'array-map';
import inArray from '../vendor/in-array';
import gnbAdult from '../../resources/gnb-adult.json';
import gnbMinor from '../../resources/gnb-minor.json';
import styles from '../styles/gnb.scss';
import tpl from './gnb-template.hbs';
import { CHANNELLING_LIST as chList } from '../config';

const chs = map(chList, (ch) => {
  const newData = map(gnbAdult, (val) => {
    const { gameList = [] } = val;
    return {
      ...val,
      gameList: filter(gameList, (game) => inArray(ch.games, game.gameName))
    };
  });

  const filtered = filter(newData, (genre) => genre.gameList.length > 0);

  return {
    type: ch.type,
    adult: ch.adult,
    list: filtered
  };
});

const bugsData = filter(chs, (ch) => ch.type === 'bugs');
const sayclubData = filter(chs, (ch) => ch.type === 'sayclub');

function getGNBData(type: string, adult: boolean) {
  switch (type) {
    case 'pmang':
      return adult ? gnbAdult : gnbMinor;
    case 'bugs':
      return adult ? bugsData[0].list : bugsData[1].list;
    case 'sayclub':
      return adult ? sayclubData[0].list : sayclubData[1].list;
    default:
      return gnbAdult;
  }
}

export function getGNBTemplate(type = 'minor', adult = true): string {
  return tpl.render({
    adult,
    styles,
    env: process.env.GNB_ENV,
    builtAt: process.env.BUILT_AT,
    pmang: type === 'pmang',
    bugs: type === 'bugs',
    sayclub: type === 'sayclub',
    simplePmang: type === 'simple-pmang',
    pageUrl: encodeURIComponent(window.location.href),
    gnbData: map(getGNBData(type, adult), (val, index) => ({
      index: index + 1,
      ...val
    }))
  });
}
